/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_TrialInputs */

const en_plan_status_trial = /** @type {(inputs: Plan_Status_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial`)
};

const es_plan_status_trial = /** @type {(inputs: Plan_Status_TrialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prueba`)
};

/**
* | output |
* | --- |
* | "Trial" |
*
* @param {Plan_Status_TrialInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_status_trial = /** @type {((inputs?: Plan_Status_TrialInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_TrialInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_status_trial(inputs)
	return en_plan_status_trial(inputs)
});